// extracted by mini-css-extract-plugin
export default {"discover":"Discover_discover__HBgLq","inner":"Discover_inner__2haFr","space":"Discover_space__VMcH-"};